import {
  ArrowDown,
  ArrowRight,
  ChatDotRound,
  ChatLineSquare,
  Check,
  Clock,
  Close,
  Collection,
  Connection,
  CopyDocument,
  Cpu,
  DataBoard,
  Delete,
  Document,
  Download,
  Expand,
  Fold,
  Folder,
  FolderOpened,
  Grid,
  Key,
  Loading,
  Lock,
  MagicStick,
  Menu,
  MoreFilled,
  Odometer,
  OfficeBuilding,
  Plus,
  Promotion,
  Refresh,
  RefreshRight,
  Setting,
  Share,
  TopRight,
  TrendCharts,
  Upload,
  UploadFilled,
  User,
} from "@element-plus/icons-vue";

export const iconComponents = {
  ArrowDown,
  ArrowRight,
  ChatDotRound,
  ChatLineSquare,
  Check,
  Clock,
  Close,
  Collection,
  Connection,
  CopyDocument,
  Cpu,
  DataBoard,
  Delete,
  Document,
  Download,
  Expand,
  Fold,
  Folder,
  FolderOpened,
  Grid,
  Key,
  Loading,
  Lock,
  MagicStick,
  Menu,
  MoreFilled,
  Odometer,
  OfficeBuilding,
  Plus,
  Promotion,
  Refresh,
  RefreshRight,
  Setting,
  Share,
  TopRight,
  TrendCharts,
  Upload,
  UploadFilled,
  User,
};

export function resolveIcon(name?: string) {
  return iconComponents[name as keyof typeof iconComponents] ?? iconComponents.Menu;
}
